import React from "react";
import "./checkboxWithLable.scss";

const CheckboxWithLable = ({ lableText }) => {
    return (
        <div className="checkbox">
            <input id="wp-comment-cookies-consent" name="wp-comment-cookies-consent" type="checkbox" />
            <label for="wp-comment-cookies-consent" className="checkbox__lable">
                {lableText}
            </label>
        </div>
    );
};

export default CheckboxWithLable;
